export enum WorkflowDatasourceStatuses {
  CREATE_SUCCEED = 'create-succeed',
  UPDATE_SUCCEED = 'update-succeed',
  CREATE_FAILED = 'create-failed',
  UPDATE_FAILED = 'update-failed',
}
